module.exports = __webpack_public_path__ + "img/dinkenclave-2.cb0f1769.jpeg";